import React from "react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  totalCount: number;
  isLoading: boolean;
  onConfirm: () => void;
}

// 전체 비우기 최종 확인 모달 — 실제 비우기 mutation은 부모(담은 상품 페이지)가 소유한다.
function PathPickBasketClearAllConfirmModal({
  isOpen,
  onClose,
  totalCount,
  isLoading,
  onConfirm,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      // 기본 폭(480px)이 화면보다 넓으면 왼쪽이 스크롤로도 닿지 않아 화면 폭으로 클램프한다.
      minWidth={"min(480px, 92dvw)"}
      isCentered
    >
      <CustomApprovalModal.Header
        title={t("path_pick:basket.clear_all_modal.title")}
        onClose={onClose}
      />
      <CustomApprovalModal.Body>
        {t("path_pick:basket.clear_all_modal.description", {
          count: totalCount,
        })}
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        confirmName={t("path_pick:basket.clear_all_modal.confirm")}
        onCancel={onClose}
        onConfirm={onConfirm}
        isLoading={isLoading}
      />
    </CustomApprovalModal>
  );
}

export default PathPickBasketClearAllConfirmModal;
